const AboutUs = {
  init: function () {
    this.initTrustedSwipper();
    this.initSatisfactionMedia();
  },

  initTrustedSwipper() {
    new Swiper(".trustedSwiper", {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".trustedSwiper .button-next",
        prevEl: ".trustedSwiper .button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
      },
    });
  },

  initSatisfactionMedia() {
    document.querySelectorAll(".iframe-poster").forEach((wrapper) => {
      const btn = wrapper.querySelector(".iframe-poster__play");
      const iframe = wrapper.querySelector(".iframe-poster__iframe");
      const poster = wrapper.querySelector(".iframe-poster__image");

      btn.addEventListener("click", () => {
        iframe.src = iframe.dataset.src;
        iframe.style.display = "block";

        btn.remove();
        poster.remove();
      });
    });
  },
};

$(function () {
  AboutUs.init();
});
